import { LayoutDashboard, Building2, Users, Wand2, PlusCircle, Terminal, History, Filter, type LucideIcon } from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  /** Hidden from nav/palette for non-SuperAdmins (the API enforces it too). */
  superAdminOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/templates', label: 'Templates', icon: LayoutDashboard },
  { path: '/tenants', label: 'Tenants', icon: Building2 },
  { path: '/users', label: 'Users', icon: Users },
  { path: '/generate', label: 'Generator', icon: Wand2 },
  { path: '/create-dashboard', label: 'Create Dashboard', icon: PlusCircle },
  { path: '/filters', label: 'Cluvio Filters', icon: Filter },
  { path: '/graphql', label: 'GraphQL Runner', icon: Terminal },
  { path: '/audit', label: 'Audit Log', icon: History, superAdminOnly: true },
];
